import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";

const initialState = {
  name: "",
  email: "",
  requiredDate: "",
  productType: "",
  size: "",
  quantity: "",
  flavor: "",
  withFilling: false,
  message: "",
};

export const Contact = (props) => {
  const [formData, setFormData] = useState(initialState);
  const [status, setStatus] = useState({ type: "", message: "" });

  // Get unique flavors from flavorsData filtered by product type
  const getUniqueFlavors = () => {
    if (!props.flavorsData) return [];

    // Filter flavors based on product type
    if (formData.productType === "Cake" || formData.productType === "3D Cake") {
      // Show only cake flavors
      const filteredData = props.flavorsData.filter(
        (item) => item.category === "cakes"
      );
      const flavors = filteredData.map((item) => item.name);
      return [...new Set(flavors)];
    } else if (formData.productType === "Cupcakes") {
      // Show only cupcake flavors
      const filteredData = props.flavorsData.filter(
        (item) => item.category === "cupcakes"
      );
      const flavors = filteredData.map((item) => item.name);
      return [...new Set(flavors)];
    } else {
      // No product type selected, return empty array
      return [];
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevState) => {
      const newState = {
        ...prevState,
        [name]: type === "checkbox" ? checked : value || "",
      };
      // Reset size and quantity when product type changes
      if (name === "productType") {
        if (value !== "Cake" && value !== "Cupcakes") {
          newState.size = "";
        }
        if (value !== "Cupcakes") {
          newState.quantity = "";
        }
        // Always clear flavor and withFilling when product type changes
        newState.flavor = "";
        newState.withFilling = false;
      }
      return newState;
    });
  };

  const clearState = () => setFormData({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus({ type: "", message: "" });

    // EmailJS configuration
    const serviceId =
      process.env.REACT_APP_EMAILJS_SERVICE_ID || "YOUR_SERVICE_ID";
    const templateId =
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "YOUR_TEMPLATE_ID";
    const publicKey =
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "YOUR_PUBLIC_KEY";

    // If EmailJS is not configured, use mailto as fallback
    if (
      serviceId === "YOUR_SERVICE_ID" ||
      templateId === "YOUR_TEMPLATE_ID" ||
      publicKey === "YOUR_PUBLIC_KEY"
    ) {
      // Fallback to mailto link
      const subject = encodeURIComponent("Cake Request");
      const body = encodeURIComponent(
        `Name: ${formData.name}\nEmail: ${formData.email}\nRequired Date: ${
          formData.requiredDate
        }\nProduct Type: ${formData.productType}\n${
          formData.size ? `Size: ${formData.size}\n` : ""
        }${formData.quantity ? `Quantity: ${formData.quantity}\n` : ""}${
          formData.flavor ? `Flavor: ${formData.flavor}\n` : ""
        }${
          formData.productType === "Cupcakes" && formData.withFilling
            ? `With Filling: Yes\n`
            : ""
        }\nMessage:\n${formData.message}`
      );
      window.location.href = `mailto:tanyaartcake.ca@gmail.com?subject=${subject}&body=${body}`;
      setStatus({
        type: "info",
        message: "Opening your email client...",
      });
      clearState();
      return;
    }

    // Send email using EmailJS
    emailjs.sendForm(serviceId, templateId, e.target, publicKey).then(
      (result) => {
        console.log(result.text);
        setStatus({
          type: "success",
          message: "Thank you! Your request has been sent successfully.",
        });
        clearState();
      },
      (error) => {
        console.log(error.text);
        setStatus({
          type: "error",
          message:
            "Sorry, there was an error sending your request. Please try again or email us directly.",
        });
      }
    );
  };

  const uniqueFlavors = getUniqueFlavors();
  const showSizeField =
    formData.productType === "Cake" || formData.productType === "Cupcakes";
  const showQuantityField = formData.productType === "Cupcakes";
  const showFlavorField = formData.productType && formData.productType !== "";
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>
                <p>
                  Please fill out the form below and I will get back to you as
                  soon as possible.
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <input
                  type="hidden"
                  name="to_email"
                  value="tanyaartcake.ca@gmail.com"
                />
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Name"
                        required
                        value={formData.name}
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        value={formData.email}
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        id="required-date"
                        name="requiredDate"
                        className="form-control"
                        placeholder="Required Date"
                        required
                        value={formData.requiredDate}
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <select
                        id="product-type"
                        name="productType"
                        className="form-control"
                        required
                        value={formData.productType || ""}
                        onChange={handleChange}
                        style={{
                          color:
                            !formData.productType || formData.productType === ""
                              ? "#ac3b61"
                              : "#333",
                        }}
                      >
                        <option value="" style={{ color: "#ac3b61" }}>
                          Select Dessert Type
                        </option>
                        <option value="Cake">Cake</option>
                        <option value="Cupcakes">Cupcakes</option>
                        <option value="3D Cake">3D Cake</option>
                      </select>
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                {showSizeField && (
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <select
                          id="size"
                          name="size"
                          className="form-control"
                          required={showSizeField}
                          value={formData.size || ""}
                          onChange={handleChange}
                          style={{
                            color:
                              !formData.size || formData.size === ""
                                ? "#ac3b61"
                                : "#333",
                          }}
                        >
                          <option value="" style={{ color: "#ac3b61" }}>
                            Select Size
                          </option>
                          {formData.productType === "Cake" && (
                            <>
                              <option value="Bento Cake (4 inch)">
                                Bento Cake (4")
                              </option>
                              <option value="Small (6 inch)">Small (6")</option>
                              <option value="Medium (7 inch)">
                                Medium (7")
                              </option>
                              <option value="Large (8 inch)">Large (8")</option>
                            </>
                          )}
                          {formData.productType === "Cupcakes" && (
                            <>
                              <option value="Small">Small</option>
                              <option value="Regular">Regular</option>
                            </>
                          )}
                        </select>
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                  </div>
                )}
                {showQuantityField && (
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <input
                          type="number"
                          id="quantity"
                          name="quantity"
                          className="form-control"
                          placeholder="Quantity"
                          required={showQuantityField}
                          min="1"
                          value={formData.quantity}
                          onChange={handleChange}
                        />
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                  </div>
                )}
                {showFlavorField && (
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <select
                          id="flavor"
                          name="flavor"
                          className="form-control"
                          value={formData.flavor || ""}
                          onChange={handleChange}
                          style={{
                            color:
                              !formData.flavor || formData.flavor === ""
                                ? "#ac3b61"
                                : "#333",
                          }}
                        >
                          <option value="" style={{ color: "#ac3b61" }}>
                            Select Flavor
                          </option>
                          {uniqueFlavors.map((flavor, index) => (
                            <option key={index} value={flavor}>
                              {flavor}
                            </option>
                          ))}
                        </select>
                        <p className="help-block text-danger"></p>
                      </div>
                    </div>
                  </div>
                )}
                {showFlavorField && formData.productType === "Cupcakes" && (
                  <div className="row" style={{ marginBottom: "10px" }}>
                    <div className="col-md-12">
                      <div className="form-group" style={{ marginBottom: "0" }}>
                        <label
                          style={{
                            color: "#eee2dc",
                            fontSize: "18px",
                            fontWeight: "600",
                            fontFamily: '"Cormorant Garamond", serif',
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            paddingLeft: "16px",
                          }}
                        >
                          <input
                            type="checkbox"
                            name="withFilling"
                            checked={formData.withFilling}
                            onChange={handleChange}
                            style={{
                              width: "20px",
                              height: "20px",
                              marginRight: "10px",
                              cursor: "pointer",
                              accentColor: "#ac3b61",
                            }}
                            className="form-control-checkbox"
                          />
                          with a filling
                        </label>
                      </div>
                    </div>
                  </div>
                )}
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Describe your dream dessert"
                    required
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                {status.message && (
                  <div
                    className={`alert ${
                      status.type === "success"
                        ? "alert-success"
                        : status.type === "error"
                        ? "alert-danger"
                        : "alert-info"
                    }`}
                    style={{
                      marginTop: "15px",
                      padding: "12px 16px",
                      borderRadius: "8px",
                      backgroundColor:
                        status.type === "success"
                          ? "#d4edda"
                          : status.type === "error"
                          ? "#f8d7da"
                          : "#d1ecf1",
                      color:
                        status.type === "success"
                          ? "#155724"
                          : status.type === "error"
                          ? "#721c24"
                          : "#0c5460",
                      border:
                        status.type === "success"
                          ? "1px solid #c3e6cb"
                          : status.type === "error"
                          ? "1px solid #f5c6cb"
                          : "1px solid #bee5eb",
                    }}
                  >
                    {status.message}
                  </div>
                )}
                <button type="submit" className="btn btn-custom btn-lg">
                  Send Message
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Contact Info</h3>
              <p>
                <span>
                  <i className="fas fa-location-dot"></i>{" "}
                  {props.data ? props.data.address : "loading"}
                </span>
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i>{" "}
                  {props.data ? props.data.email : "loading"}
                </span>
              </p>
            </div>
            <div className="social">
              <ul>
                <li>
                  <a href={props.data ? props.data.youtube : "/"}>
                    <i className="fab fa-telegram"></i>
                  </a>
                </li>
                <li>
                  <a href={props.data ? props.data.twitter : "/"}>
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href={props.data ? props.data.facebook : "/"}>
                    <i className="fab fa-facebook"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>© 2025 Tanya Klimova</p>
        </div>
      </div>
    </div>
  );
};
